<div class="mat-typography">
    <p>Initial rows count: {{data?.initialCount}}</p>
    <p>Processed rows count: {{data?.processedCount}}</p>
    <p>Succeed operations count: {{data?.successCount}}</p>
    <p>Applied operations count: {{data?.appliedCount}}</p>
    <p>Failed operations count: {{data?.failedCount}}</p>
    <p>Failed records ids: {{failedRecordsIdsStr}}</p>
</div>